import React from 'react';
import OrderPage from '../../OrderPage';
import OrderDetails from '../OrderDetails';
import { OrderTarget } from '../../../components/OrdersTable/interfaces/OrderStatus.interface';

const AdminOrderPage: React.FC = () => (
	<OrderPage
		target={OrderTarget.admin}
		renderDetails={({ order, isOpen, onBack }) => (
			<OrderDetails
				key={order.id}
				isOpen={isOpen}
				selectedOrder={order}
				position="relative"
				onBack={onBack}
				hideMap
				closeOnClickOutside={false}
			/>
		)}
	/>
);

export default AdminOrderPage;
